import { createFileRoute } from '@tanstack/react-router';
import api from '@/api';
import { ArticleDetailScreen } from '@/common/ArticleDetailScreen';
import { toArticleDetail } from '@/posts/posts';

// The old site addressed student news at /student-news/<slug>, so we keep that
// URL working. The kind comes from the URL (not the viewer's role) so the link
// resolves to the same article regardless of who opens it.
export const Route = createFileRoute('/_app/student-news/$slug')({
  component: StudentNewsDetailScreen,
});

function StudentNewsDetailScreen() {
  const { slug } = Route.useParams();
  const { data, isPending } = api.getPost.useQuery({
    path: { slug },
    query: { kind: 'student_news' },
  });
  const article = data ? toArticleDetail(data) : undefined;

  return (
    <ArticleDetailScreen
      article={article}
      isLoading={isPending}
      backPath="/news"
      // Translation Needed
      notFoundMessage="News article not found"
    />
  );
}
